import { Controller } from 'stimulus';

export default class extends Controller {
  toggleDropdown(e) {
    let dropdownEl = e.target.parentElement;
    if (dropdownEl.classList.contains('toggle')) dropdownEl = dropdownEl.parentElement;
    dropdownEl.classList.toggle('-is-open');
  }
}
